import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-format-italic",
  templateUrl: "./med-icon-format-italic.component.html",
})
export class MedIconFormatItalicComponent extends SvgMixinComponent {}
